import { render } from "./FlatsTable.vue?vue&type=template&id=43bf189d&scoped=true"
import script from "./FlatsTable.vue?vue&type=script&lang=js"
export * from "./FlatsTable.vue?vue&type=script&lang=js"

import "./FlatsTable.vue?vue&type=style&index=0&id=43bf189d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43bf189d"]])

export default __exports__